import { ProfileURL } from "../../shared/profileURL";
import { NextButton } from "../NextButton/NextButton";
import {
  GithubIcon,
  LinkedinIcon,
  MailIcon,

  TickIcon,
  TwitterIcon,


} from "../../shared/assets";
import { Icon } from "@iconify/react";
import { ViewResumeAnchor } from "../../ui/atoms/ViewResumeBtn";
import { FaLocationDot } from "react-icons/fa6";

const SKILLS = [
  {
    text: "Full-stack Developer",
  },
  {
    text: "AI & Automation Enthusiast",
  },
  // {
  //   text: "Problem Solver with Code",
  // },
  {
    text: "Open-Source Advocate",
  },
];



export function Banner() {
  return (
    <div className="min-h-screen pt-[5rem] md:pt-[200px] relative font-nunito text-[#f7f7f7] ">
      <div className="max-w-8xl mx-auto px-4 sm:px-6 lg:px-[5%] pt-20 pb-16">
        <div className="">
          <div className="space-y-8">
            <div className="space-y-8 ">
              <h3 className="text-primary-600 text-lg md:text-2xl font-semibold tracking-wide mb-8 ">Hello World 👋, I'am </h3>
              <h1 className="text-5xl lg:text-8xl font-bold  font-nunito text-primary-600  text-shadow-lg text-shadow-white/20 ">
                Samuel Yakubu
              </h1>
              <p className="text-base md:text-2xl text-gray-300 flex items-baseline gap-2 leading-none h-6 ">
                {/* <Icon icon="ion:location-sharp" fontSize={18} /> */}
                <Icon icon='gis:poi-map' fontSize={18}/>
                <span> Kaduna, Nigeria</span>
              </p>
            </div>

            <div className="bg-dark-800/50 backdrop-blur-sm rounded-xl p-6 space-y-4 ">
              <h4 className="text-xl font-semibold text-primary-600">What I Do</h4>
              <ul className="space-y-3">
                {SKILLS.map((skill, index) => (
                  <li
                    key={index}
                    className="flex items-center  space-x-3 group transition-all duration-200 ease-in-out"
                  >
                    <span className="text-primary-600 transform group-hover:scale-110 transition-transform ">
                      <TickIcon width={20} height={20} className="text-sm text-red-500"  />
                    </span>
                    <span className="group-hover:text-primary-600 text-lg md:text-xl">{skill.text}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="space-y-6 flex flex-col ">
              <ViewResumeAnchor />

              <div className="flex items-center space-x-6">
                {[
                  { icon: TwitterIcon, url: ProfileURL.twitter },
                  { icon: GithubIcon, url: ProfileURL.github },
                  { icon: LinkedinIcon, url: ProfileURL.linkedin },
                  { icon: MailIcon, url: ProfileURL.mail },
                ].map((social, index) => (
                  <a
                    key={index}
                    href={social.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="transform hover:scale-110 transition-transform hover:text-primary-600"
                  >
                    <social.icon width={28} height={28} />
                  </a>
                ))}
              </div>
            </div>
          </div>

          {/* <div className="hidden lg:block">
            <div className="rounded-sm relative w-full h-[500px] overflow-hidden bg-gradient-to-tr from-primary-600/20 to-primary-400/20 backdrop-blur-xl">
              <img src={WorkspaceJpg  } alt="Skills" className="w-full h-full object-cover grayscale-[120%] "/>

            </div>
          </div> */}
        </div>
      </div>
     
        <NextButton nextRoute="/about" titleProp={"See more about me"}/>
    </div>
  );
} 